const state = {
    // 存储进度时间
    deadCountDown: 0
}

const mutations = {
    // 设置倒计时
    setDeadCountDown(state, deadCountDown) {
        state.deadCountDown = deadCountDown
    }

}

const actions = {
    // 设置倒计时
    setDeadCountDown({ commit }, deadCountDown) {
        commit('setDeadCountDown', deadCountDown)
    }
}

const getters = {
    // 获取倒计时
    getDeadCountDown(state) {
        return state.deadCountDown
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}